import { Component, EventEmitter, Input, OnInit, Output, AfterViewInit, OnDestroy } from '@angular/core';
import { FormBuilder, FormControl, FormGroup, Validators } from '@angular/forms';
import { ApiService } from '@services/api.service';
import { LocalizationService } from '@services/localization.service';

import { UiHelper } from '@helpers/ui.helper';
import { UserHelper } from '@helpers/user.helper';
import { TranslatePipe } from '@pipes/translate.pipe';
import { Router } from '@angular/router';
import { ActivatedRoute } from '@angular/router';
import { DataHelper } from '@helpers/data.helper';
import { MatDialog } from '@angular/material/dialog';
import { OddModel } from './sports.component';

@Component({
  selector: 'results-component',
  templateUrl: '../sharedTemplates/results.component.html',
})
export class ResultsComponent implements OnInit, AfterViewInit {
  sportId = 0;
  resultSportsList = [];
  resultCategoriesList = [];
  resultsTournamentsList = [];
  resultList = [];

  constructor(
    private _UiHelper: UiHelper,
    private _ApiService: ApiService,
    private _route: ActivatedRoute,
    private _router: Router,
    public _UserHelper: UserHelper,
    public _LocalizationService: LocalizationService,
    public _DataHelper: DataHelper,
    public _MatDialog: MatDialog
  ) {}

  ngOnInit() {
    this.getResultSports();
    this._UiHelper.setLoadingDialog(false);
  }

  ngAfterViewInit() {
    this._UiHelper.setLoadingDialog(false);
    this._UiHelper.setNavbarTitle('Results', true);
  }

  getResultSports() {
    this._ApiService.getResultSports().then(resultSports => {
      this.resultSportsList = resultSports;
      if (this._UiHelper.leftMenu) this._UiHelper.setLeftMenu();
    });
  }

  getResultCategories(sportId) {
    this._UiHelper.setLoadingDialog(true);
    this.sportId = sportId;
    this._ApiService.getResultCategories(sportId).then(ResultCategories => {
      //////console.log("OutrightCategories", OutrightCategories);
      this.resultCategoriesList = ResultCategories;
      this._UiHelper.setLoadingDialog(false);
    });
    this._UiHelper.setLoadingDialog(false);
  }

  getTournamentsByCategoryId(categoryId, sportId) {
    this._UiHelper.setLoadingDialog(true);
    this._ApiService
      .getTournamentsByCategoryId(categoryId, sportId, 360)
      .then(resultsTournaments => {
        this.resultsTournamentsList = resultsTournaments;
        this._UiHelper.setLoadingDialog(false);
      })
      .catch(err => {
        console.log('results', err);
      });
    this._UiHelper.setLoadingDialog(false);
  }

  getResultsList(CategoryId, TournamentId, TournamentName) {
    this._UiHelper.setLoadingDialog(true);
    this._ApiService.getResultsList(CategoryId, this.sportId, TournamentId, TournamentName, 1).then(resultList => {
      //////console.log("resultList", resultList);
      this.resultList = resultList;
      this._UiHelper.setLoadingDialog(false);
    });
    this._UiHelper.setLoadingDialog(false);
  }
}
